import { IState } from '../../interfaces/state.interface';
import { fromJS, List } from 'immutable';
import { IReducer } from '../../interfaces/reducer.interface';
import { IAction } from '../../interfaces/action.interface';
import { mergeState } from '../../utils/reducer';
import { RegionsActionTypes } from './regions.action-types';
import { RegionModel } from '../../models/region.model';

// TODO: Replace all new Date()'s accordingly with https://webartig.atlassian.net/browse/PUB-115
const initialState: IState = fromJS({
  regions: List<RegionModel>(),
  updatedAt: null,
  updatedByTitle: null
});

export const regionsReducer: IReducer = (state = initialState, action: IAction) => {
  switch (action.type) {
    case RegionsActionTypes.SET_REGIONS:
      return mergeState(state, {
        regions: List<RegionModel>(action.payload?.map(data => new RegionModel(data))),
        updatedAt: action.payload[0]?.updatedAt,
        updatedByTitle: action.payload[0]?.updatedByTitle,
      })

    case RegionsActionTypes.DELETE_REGION:
      const deleteIndex = state.get('regions').findIndex((region: RegionModel) => region.id === action.payload);
      return mergeState(state, {
        regions: state.get('regions').remove(deleteIndex)
      })

    case RegionsActionTypes.UPDATE_REGION:
      const updateStateTemplates = state.get('regions') as List<RegionModel>;
      const updateIndex = updateStateTemplates.findIndex((region: RegionModel) => region.id === action.payload.id);
      const updateData = new RegionModel(action.payload);
      return mergeState(state, {
        regions: updateStateTemplates.splice(updateIndex, 1, updateData),
        updatedAt: updateData.updatedAt,
        updatedByTitle: updateData.updatedByTitle,
      })

    case RegionsActionTypes.CREATE_REGION:
      const newRegion = new RegionModel({
        id: action.payload.id,
        title_de: action.payload.title_de,
        title_en: action.payload.title_en,
      });

      const createStateTemplates = state.get('regions') as List<RegionModel>;

      return mergeState(state, {
        regions: List([newRegion, ...createStateTemplates]),
        updatedAt: action.payload.updatedAt,
        updatedByTitle: action.payload.updatedByTitle,
      })

    case RegionsActionTypes.ADD_POSTAL_CODE:
      const updatedState = ((state: IState) => {
        const currentRegions = state.get('regions') as RegionModel[];
        const selectedRegion = currentRegions.find((region) => region.id === action.payload.regionId);
        const postalCodes = List(selectedRegion.postalCodes);
        const updatedPostalCodes = postalCodes.push(action.payload.postalCode);
        return {
          regions: currentRegions.map(region => {
            if (region.id !== action.payload.regionId) {
              return region;
            }

            return region.set('postalCodes', updatedPostalCodes.toJSON());
          }),
          updatedAt: new Date().toISOString(),
          updatedByTitle: action.payload.updatedByTitle
        };
      })(state);
      return mergeState(state, updatedState);

    case RegionsActionTypes.REMOVE_POSTAL_CODE:
      const currentRegions = state.get('regions') as RegionModel[];
      const selectedRegion = currentRegions.find((region) => region.id === action.payload.regionId);
      const postalCodeIndex = selectedRegion.postalCodes.indexOf(action.payload.postalCode);
      const updatedPostalCodes = List(selectedRegion.postalCodes).remove(postalCodeIndex);

      return mergeState(state, {
        regions: currentRegions.map(region => {
          if (region.id !== action.payload.regionId) {
            return region;
          }
          return region.set('postalCodes', updatedPostalCodes.toJSON());
        }),
        updatedAt: new Date().toISOString(),
        updatedByTitle: action.payload.updatedByTitle
      });

    default:
      return state;
  }
}
